export default __webpack_public_path__ + "static/media/element_41.d5d3c5cd.webp";